import React, { Component } from 'react';
import { Descriptions, Space } from 'antd';

const data = [
  {
    title: 'Overall Status',
    status: 'Completed'
  },
  {
    title: 'Setting up Queue',
    status: 'Completed'
  },
  {
    title: 'Training Completion',
    status: 'Completed'
  },
  {
    title: 'Prediction Completion',
    status: 'Completed'
  }
];

const reportData = [data, data, data];

class ReportTab extends Component {
  render() {
    return (
      <Space size={'small'} direction={'vertical'}>
        <Descriptions column={1} title="Progress">
          {data.map((eachObject) => {
            const { status, title } = eachObject;
            return (
              <Descriptions.Item label={title}>{status}</Descriptions.Item>
            );
          })}
        </Descriptions>
        ,<div className="ant-descriptions-title">Report</div>
        <Space
          style={{
            background: '#F7F7F8',
            padding: 20
          }}
          size={'large'}
          direction={'vertical'}>
          {reportData.map((reportArray) => {
            return (
              <Descriptions
                style={{ borderLeft: '4px solid #748AA1' }}
                column={1}>
                {reportArray.map((reportObject) => {
                  const { status, title } = reportObject;
                  return (
                    <Descriptions.Item
                      labelStyle={{ marginLeft: 15 }}
                      label={title}>
                      {status}
                    </Descriptions.Item>
                  );
                })}
              </Descriptions>
            );
          })}
        </Space>
      </Space>
    );
  }
}

ReportTab.propTypes = {};

export default ReportTab;
